<template>
  <q-toggle
    :value="vModel"
    v-bind="vAttrs"
    v-on="$listeners"
  >
    <slot />
  </q-toggle>
</template>

<script>/**
 * Proxy le composant QToggle avec un model à false par défaut
 * @extends QToggle
 */

import propsReadonly from '@/mixins/propsReadonly'

export default {
  name: 'LwfToggle',
  mixins: [propsReadonly],
  props: {
    /**
     * @model
     */
    value: {
      type: [Boolean, Number, String],
      default: undefined
    }
  },
  computed: {
    vModel () {
      return (typeof this.value === 'undefined' || this.value === null) ? false : this.value
    },
    vAttrs () {
      return {
        color: 'positive',
        disable: this.readonly,
        ...this.$attrs
      }
    }
  }
}
</script>

<style scoped>

</style>
